module.exports = __webpack_public_path__ + "static/media/YGY_Products@2x.af1f6b13.png";